import { render, staticRenderFns } from "./VideoInsert.vue?vue&type=template&id=a47e00c0&scoped=true&"
import script from "./VideoInsert.vue?vue&type=script&lang=js&"
export * from "./VideoInsert.vue?vue&type=script&lang=js&"
import style0 from "./VideoInsert.vue?vue&type=style&index=0&id=a47e00c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47e00c0",
  null
  
)

export default component.exports